import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const WIKI_VIDEO_URL = 'https://www.youtube.com/embed/N2LPyZpwmpU';

const WikiVideoModal = ({ show, onHide }) => {
	return (
		<Modal show={show} onHide={onHide} size="lg" centered>
			<Modal.Header closeButton>
				<Modal.Title>Wiki - Video introduttivo</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
					{show && (
						<iframe
							src={WIKI_VIDEO_URL}
							title="Wiki SportID"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen
							style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
						/>
					)}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="primary" onClick={onHide}>Chiudi</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default WikiVideoModal;
